var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewManageMonitors01 = function SvgViewManageMonitors01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "view_manage_monitors-01_svg2__a",
    x1: 13.58,
    x2: 200.31,
    y1: 181.28,
    y2: 5.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a80096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__b",
    x1: -64.78,
    x2: 121.95,
    y1: 97.97,
    y2: -77.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__c",
    x1: -56.96,
    x2: 129.77,
    y1: 106.29,
    y2: -69.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__d",
    x1: -49.13,
    x2: 137.6,
    y1: 114.61,
    y2: -61.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__e",
    x1: 8.76,
    x2: 195.49,
    y1: 176.16,
    y2: 0.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__f",
    x1: -29.75,
    x2: 156.98,
    y1: 135.21,
    y2: -40.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__g",
    x1: -25.84,
    x2: 160.89,
    y1: 139.37,
    y2: -36.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__h",
    x1: -4.8,
    x2: 181.93,
    y1: 161.74,
    y2: -13.88
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__i",
    x1: -0.89,
    x2: 185.84,
    y1: 165.9,
    y2: -9.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__j",
    x1: 20.15,
    x2: 206.88,
    y1: 188.27,
    y2: 12.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__k",
    x1: 24.06,
    x2: 210.79,
    y1: 192.43,
    y2: 16.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__l",
    x1: 0.76,
    x2: 187.49,
    y1: 167.65,
    y2: -7.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__m",
    x1: 25.71,
    x2: 212.44,
    y1: 194.18,
    y2: 18.56
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__n",
    x1: 50.66,
    x2: 237.39,
    y1: 220.71,
    y2: 45.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__o",
    x1: 22,
    x2: 208.73,
    y1: 190.23,
    y2: 14.61
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__p",
    x1: 46.95,
    x2: 233.68,
    y1: 216.76,
    y2: 41.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#view_manage_monitors-01_svg2__a",
    id: "view_manage_monitors-01_svg2__q",
    x1: 71.9,
    x2: 258.63,
    y1: 243.29,
    y2: 67.67
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M190 0H10C4.48 0 0 4.48 0 10v180c0 5.52 4.48 10 10 10h180c5.52 0 10-4.48 10-10V10c0-5.52-4.48-10-10-10M6.67 10c0-1.84 1.49-3.33 3.33-3.33h180c1.84 0 3.33 1.49 3.33 3.33v16.67H6.67zm186.66 180c0 1.84-1.49 3.33-3.33 3.33H10c-1.84 0-3.33-1.49-3.33-3.33V33.33h186.67V190Z",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.33 13.33H20c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h3.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 13.33h-3.33c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33H40c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.67 13.33h-3.33c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h3.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 13.33h-3.33c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33H180c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.67 83.33h40c5.52 0 10-4.48 10-10v-20c0-5.52-4.48-10-10-10h-40c-5.52 0-10 4.48-10 10v20c0 5.52 4.48 10 10 10M40 50h26.67c1.84 0 3.33 1.49 3.33 3.33v20c0 1.84-1.49 3.33-3.33 3.33H40V49.99Zm-13.33 0h6.67v26.67h-6.67c-1.84 0-3.33-1.49-3.33-3.33v-20c0-1.84 1.49-3.33 3.33-3.33Z",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 60H50c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h10c1.84 0 3.33-1.49 3.33-3.33S61.84 60 60 60",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.67 133.33h40c5.52 0 10-4.48 10-10v-20c0-5.52-4.48-10-10-10h-40c-5.52 0-10 4.48-10 10v20c0 5.52 4.48 10 10 10M40 100h26.67c1.84 0 3.33 1.49 3.33 3.33v20c0 1.84-1.49 3.33-3.33 3.33H40V99.99Zm-13.33 0h6.67v26.67h-6.67c-1.84 0-3.33-1.49-3.33-3.33v-20c0-1.84 1.49-3.33 3.33-3.33Z",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 110H50c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h10c1.84 0 3.33-1.49 3.33-3.33S61.84 110 60 110",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.67 183.33h40c5.52 0 10-4.48 10-10v-20c0-5.52-4.48-10-10-10h-40c-5.52 0-10 4.48-10 10v20c0 5.52 4.48 10 10 10M40 150h26.67c1.84 0 3.33 1.49 3.33 3.33v20c0 1.84-1.49 3.33-3.33 3.33H40v-26.67Zm-13.33 0h6.67v26.67h-6.67c-1.84 0-3.33-1.49-3.33-3.33v-20c0-1.84 1.49-3.33 3.33-3.33Z",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 160H50c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h10c1.84 0 3.33-1.49 3.33-3.33S61.84 160 60 160",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 66.67h43.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H90c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 116.67h43.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H90c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 166.67h43.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H90c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.31 72.36c1.3 1.3 3.41 1.3 4.71 0l16.67-16.67c1.26-1.31 1.25-3.39-.04-4.67a3.33 3.33 0 0 0-4.67-.04l-14.31 14.31-4.31-4.31c-1.31-1.26-3.39-1.25-4.67.04a3.33 3.33 0 0 0-.04 4.67l6.67 6.67Z",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.31 122.36c1.3 1.3 3.41 1.3 4.71 0l16.67-16.67c1.26-1.31 1.25-3.39-.04-4.67a3.33 3.33 0 0 0-4.67-.04l-14.31 14.31-4.31-4.31c-1.31-1.26-3.39-1.25-4.67.04a3.33 3.33 0 0 0-.04 4.67l6.67 6.67Z",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.31 172.36c1.3 1.3 3.41 1.3 4.71 0l16.67-16.67c1.26-1.31 1.25-3.39-.04-4.67a3.33 3.33 0 0 0-4.67-.04l-14.31 14.31-4.31-4.31c-1.31-1.26-3.39-1.25-4.67.04a3.33 3.33 0 0 0-.04 4.67l6.67 6.67Z",
    style: {
      fill: "url(#view_manage_monitors-01_svg2__q)"
    }
  }));
};
export default SvgViewManageMonitors01;